module.exports = __webpack_public_path__ + "static/media/twitter.4fed5bd7.png";